import { useEffect } from 'react';
import worldTrigger from 'world-trigger';
export const useWorldTrigger = (triggerName, callback, deps = []) => {
  useEffect(() => {
    worldTrigger.addTrigger(triggerName, callback);
    return () => worldTrigger.removeTrigger(triggerName, callback);
  }, deps);
};